import * as React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider, styled } from "@mui/material/styles";
import { CssBaseline, Drawer, Divider, IconButton, Paper } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

import SidebarLayoutContextProvider, {
  useSidebarLayoutContext,
} from "contexts/SidebarLayoutContext";

import AppBar from "./AppBar";
import MainContent from "./MainContent";
import AppLogo from "components/Shared/AppLogo";
import AppConfetti from "components/Shared/AppConfetti";
import NetworkStatus from "components/NetworkStatus";

import { NotificationProvider } from "contexts/NotificationContext";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  color: theme.palette.text,
  justifyContent: "flex-end",
}));

const SLayout = ({
  sidebar: Sidebar = null,
  appBarContent: AppBarContent = null,
}) => {
  const { showSidebar, setShowSidebar, drawerWidth, theme } =
    useSidebarLayoutContext();

  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <Paper sx={{ display: "flex", minHeight: "100vh" }}>
          <CssBaseline />

          <AppBar appBarContent={AppBarContent} />

          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                boxSizing: "border-box",
              },
            }}
            variant="persistent"
            anchor="left"
            open={showSidebar}
          >
            <DrawerHeader>
              <div className="mx-auto">
                <AppLogo />
              </div>

              <IconButton onClick={() => setShowSidebar(false)}>
                {theme.direction === "ltr" ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>
            </DrawerHeader>

            <Divider />

            {Sidebar && <Sidebar />}
          </Drawer>

          <MainContent
            open={showSidebar}
            drawerwidth={drawerWidth}
            style={{
              flexGrow: 1,
              marginTop: "-0.7rem",
              maxWidth: !showSidebar ? "100%" : `calc(100% - ${drawerWidth}px)`,
            }}
          >
            <>
              <DrawerHeader />

              <Outlet />

              <NetworkStatus />
            </>
          </MainContent>

          <AppConfetti />
        </Paper>
      </NotificationProvider>
    </ThemeProvider>
  );
};

function SidebarLayout(props) {
 

  // React.useEffect(() => {
  //   if (!isSystem) return;

  //   const socket = getSocketInstance();

  //   if (!socket) return;

  //   // socket.on(BROADCAST_CONSTANTS.ADD_NEW_BROADCAST, (broadcast) => {
  //   //   const { scope, entity, account } = broadcast;

  //   //   const _loggedInAccount = viewEntity?.entity?.account?._id;
  //   //   const _loggedInEntity = viewEntity?.entity?._id;
  //   //   const _loggedInScope = viewEntity?.authorization?.level;

  //   //   switch (_loggedInScope) {
  //   //     case "System":
  //   //       sendDesktopNotification(broadcast);
  //   //       break;

  //   //     case "Account":
  //   //       if (scope !== "System" && account === _loggedInAccount)
  //   //         sendDesktopNotification(broadcast);

  //   //       break;

  //   //     case "Entity":
  //   //       if (
  //   //         account === _loggedInAccount &&
  //   //         scope === "Entity" &&
  //   //         _loggedInEntity === entity
  //   //       )
  //   //         sendDesktopNotification(broadcast);

  //   //       break;

  //   //     default:
  //   //       break;
  //   //   }
  //   // });

  //   return () => socket.off(BROADCAST_CONSTANTS.ADD_NEW_BROADCAST);
  // }, [sendDesktopNotification, isSystem, viewEntity]);

  return (
    <SidebarLayoutContextProvider>
      <SLayout {...props} />
    </SidebarLayoutContextProvider>
  );
}

export default SidebarLayout;
